import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=507f8e78&"
import script from "./Trading.vue?vue&type=script&lang=js&"
export * from "./Trading.vue?vue&type=script&lang=js&"
import style0 from "./Trading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports